export default {
  path: 'apartados',
  children: [
    {
      path: '',
      component: () => import('pages/reservations/IndexPage.vue'),
      children: [
        {
          path: '',
          name: 'reservations.index',
          component: () => import('components/reservations/TabDashboard.vue'),
        },
        {
          path: 'v2',
          name: 'reservations.index.v2',
          component: () => import('components/reservations/TabDashboardV2.vue'),
        },
        {
          path: 'report',
          name: 'reservations.report',
          component: () => import('components/reservations/CardReport.vue'),
        },
        {
          path: 'list',
          name: 'reservations.list',
          component: () => import('components/reservations/TabReservationList.vue'),
        },
      ],
    },
    {
      path: ':id',
      name: 'reservations.read',
      component: () => import('pages/reservations/ReadPage.vue'),
    },
  ],
}
